const VariantTabHandler = {
  selectors: {
    variantSpace: '.variant-space',
    radioInput: 'input[type="radio"]',
    tabWrapper: '.ishi-tabs'
  },

  groups: [
    {
      tab: "tab-1",
      variants: {
        title: "Shower Filter",
        ids: ["template--16814548025603__main-1-0", "template--16814548025603__main-1-1"]
      }
    },
    {
      tab: "tab-2",
      variants: {
        title: "Multi-Spray Shower Head",
        ids: ["template--16814548025603__main-1-2", "template--16814548025603__main-1-3"]
      }
    },
    {
      tab: "tab-3",
      variants: {
        title: "Luxe Flow Shower Head",
        ids: ["template--16814548025603__main-1-4", "template--16814548025603__main-1-5"]
      }
    },
    {
      tab: null,
      variants: {
        title: "Replacement Cartridge",
        ids: ["template--16814548025603__main-1-6"]
      }
    }
  ],

  titleStyle: `
    display: block;
    color: #018165;
    text-align: center;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600
  `,

  init() {
    this.injectTitles()
    this.bindEvents()
    this.checkInitialSelection()
  },

  injectTitles() {
    this.groups.forEach(group => {
      const firstId = group.variants.ids[0]
      if (firstId) {
        const span = $('<span>', { 
          text: group.variants.title,
          style: this.titleStyle
        })
        $(`#${firstId}`).before(span)
      }
    })
  },

  checkInitialSelection() {
    setTimeout(() => {
      const selectedInput = $(this.selectors.variantSpace)
        .find(`${this.selectors.radioInput}:checked`)
      
      if (selectedInput.length) {
        this.handleVariantSelection(selectedInput.attr('id'))
      }
    }, 1000)
  },

  bindEvents() {
    $(this.selectors.variantSpace).on('change', this.selectors.radioInput, (e) => {
      this.handleVariantSelection(e.target.id)
    })
  },

  handleVariantSelection(variantId) {
    const group = this.groups.find(group => 
      group.variants.ids.includes(variantId)
    )
    
    if (group?.tab) {
      this.selectTab(group.tab)
    }
  },

  selectTab(tabId) {
    $(`${this.selectors.tabWrapper} [data-href="#${tabId}"]`).trigger('click')
  }
}

$(() => VariantTabHandler.init())